import { CreditsInput, InstructionLanguageInput, NationalityInput } from "./Partials";

const CreditFields = () => (
  <>
    <NationalityInput isRequired />
    <InstructionLanguageInput label="Език на преподаване" />
    <CreditsInput md={12} />
  </>
);

export default CreditFields;
